<div ngModelGroup="cbProjeto" fxFlex="40%" fxLayoutGap="20px" fxFlexOffset="20px">
    <combo-projeto [showDisplayId]="false" #campoProjeto
                   [obrigatorio]="true" 
                   [selecionado]="filtro.projeto"
                   (valorChange)="onValorChangeProjeto($event)">
    </combo-projeto>
</div>


<mat-form-field fxFlex fxFlexOffset="20px">
    <input [(ngModel)]=rateio.valorRateio 
           currencyMask 
           name="valor_{{pinValor}}"
           placeholder={{rateio.placeHolderRateio}}
           matInput 
           maxlength="13"
           [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
    <span matPrefix *ngIf="!rateio.statusPercentual">R$&nbsp;</span>
    <span matSuffix *ngIf="rateio.statusPercentual" style="padding-left: 5px;">%&nbsp;</span>
</mat-form-field> 

<div fxFlex="10%" style="margin-top: 18px;margin-left: 26px;" >
    <mat-checkbox color="primary"
                  title="Escolha a forma de rateio entre % ou R$" 
                  name="checkRateio_{{pinCheckRateio}}" 
                  [(ngModel)]="rateio.statusPercentual">
        (%)
    </mat-checkbox>

    <button mat-icon-button 
            *ngIf="perfilAcesso.deleta" 
            (click)="deletarRateio()"
            style="padding: 0px;">
        <mat-icon>delete_forever</mat-icon>
    </button>                                
</div>
